import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAiCostsCurrent } from "@/hooks/use-ai-costs";
import { useBrandContext } from "@/contexts/brand-context";

export function BudgetExhaustedBanner() {
  const { t } = useTranslation("dashboard");
  const { brand } = useBrandContext();
  const [dismissed, setDismissed] = useState(false);
  const { data } = useAiCostsCurrent(brand?.id ?? "");
  if (!data || !data.cap) return null;
  const exhausted = !data.overrideActive && data.percentUsed >= 1;
  if (!exhausted || dismissed) return null;
  return (
    <div className="flex items-center justify-between gap-3 bg-red-600 px-4 py-2 text-sm text-white">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>{t("budgetBanner.message")}</span>
      </div>
      <div className="flex items-center gap-3">
        <Link to={`/${brand?.slug}/settings/ai-usage`} className="underline">
          {t("budgetBanner.goToSettings")}
        </Link>
        <button onClick={() => setDismissed(true)} className="opacity-80 hover:opacity-100">
          {t("budgetBanner.dismiss")}
        </button>
      </div>
    </div>
  );
}
